import React from 'react';
import { string } from 'prop-types';
import classNames from 'classnames';
import { Field } from 'react-final-form';

import css from './FieldMinAmountPerHour.module.css';

const FieldMinAmountPerHour = (props) => {
  const {
    className,
    id,
    price,
    selected,
    ...rest
  } = props;
  const classes = classNames(css.root, className, {
    [css.selected]: id === selected
  });

  return (
    <div className={classes}>
      <Field className={css.input} component="input" id={id} type="radio" value={id} {...rest} />
      <label className={css.label} htmlFor={id}>{price}</label>
    </div>
  )
}

FieldMinAmountPerHour.defaultProps = {
  className: null,
  selected: null
};

FieldMinAmountPerHour.propTypes = {
  className: string,
  id: string.isRequired,
  price: string.isRequired,
  selected: string,
};

export default FieldMinAmountPerHour;
